import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import Button from 'components/Button';
import translating from '../../translate.json';

import './styles.scss';

const Upload = ({ handleSaveFile, disabled, fileType }) => {
  const [file, setFile] = useState();
  const [disabaledBtn, setDisableBtn] = useState(false);

  const handleUploadFile = (e) => {
    setFile(e.target?.files?.[0]);
  };

  useEffect(() => {
    if (disabled === true) setDisableBtn(true);
  }, [disabled]);

  return (
    <div className="wrapper-file-upload">
      <label className="custom-file-upload">
        <input type="file" onChange={handleUploadFile} accept={fileType} />
      </label>
      {file && <div className="file-name">{file.name}</div>}

      <Button
        disable={!file || (file && disabaledBtn)}
        txt={translating.loadFile}
        handleClick={() => handleSaveFile(file)}
      ></Button>
    </div>
  );
};
const UploadBasic = ({ handleSaveFile, fileType }) => {
  const handleUploadFile = (e) => {
    handleSaveFile(e.target?.files?.[0]);
  };

  return (
    <div className="wrapper-file-upload">
      <label className="custom-file-upload">
        <input type="file" onChange={handleUploadFile} accept={fileType} />
      </label>
    </div>
  );
};

export { UploadBasic };

UploadBasic.propTypes = {
  handleSaveFile: PropTypes.func,
  fileType: PropTypes.string,
};

export default Upload;

Upload.propTypes = {
  handleSaveFile: PropTypes.func,
  disabled: PropTypes.bool,
  fileType: PropTypes.string,
};
